import { render } from "./importStructure.vue?vue&type=template&id=cfb32364"
import script from "./importStructure.vue?vue&type=script&lang=js"
export * from "./importStructure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__